import gql from 'graphql-tag';

import { cardCategoryDetails } from '../../../../apps/cards/graphql/fragments/cardCategoryDetails';

const getCardCategoriesQuery = gql`
  query getCardCategoriesQuery(
    $offset: Int = 0
    $limit: Int = 20
    $is_active: Boolean = true
    $push_notification_type: CardCategoryPushNotificationTypeEnum
    $excluded_push_notification_types: [CardCategoryPushNotificationTypeEnum!]
    $card_category_id: RecordID
    $parent_card_category_id: RecordID
    $root_only: Boolean = true
  ) {
    cardCategories(
      slice: { offset: $offset, limit: $limit }
      is_active: $is_active
      push_notification_type: $push_notification_type
      excluded_push_notification_types: $excluded_push_notification_types
      card_category_id: $card_category_id
      parent_card_category_id: $parent_card_category_id
      root_only: $root_only
    ) {
      total
      records {
        ...cardCategoryDetails
        card_groups {
          total
        }
      }
    }
  }
  ${cardCategoryDetails}
`;

export default getCardCategoriesQuery;
